import { Controller } from '@hotwired/stimulus'

// Cycles answer panels: a select or prev/next on the review and present-mode slides,
// a counter on pre-deck lessons' slides.
//
// persistKey is keyed the way the retired response-carousel was, so a teacher's
// position survives both present mode's Turbo re-renders and the upgrade.
export default class extends Controller {
  static targets = ['select', 'answer', 'counter']
  static values = { persistKey: String }

  connect() {
    // A Turbo cache restore keeps the hidden classes, so a reconnect resumes
    // where the teacher was rather than bouncing to the first answer.
    let index = Math.max(0, this.answerTargets.findIndex(panel => !panel.classList.contains('hidden')))
    if (this.hasPersistKeyValue) {
      const savedId = localStorage.getItem(this.persistKeyValue)
      const saved = this.answerTargets.findIndex(panel => panel.dataset.id === savedId)
      if (saved >= 0) index = saved
    }
    this.show(index)
  }

  change() {
    this.show(Number(this.selectTarget.value))
  }

  previous() {
    this.step(-1)
  }

  next() {
    this.step(1)
  }

  step(delta) {
    const count = this.answerTargets.length
    if (count === 0) return

    // Wraps both ways, so stepping past either end comes round again.
    this.show((this.index + delta + count) % count)
  }

  show(index) {
    this.index = index
    this.answerTargets.forEach((panel, i) => panel.classList.toggle('hidden', i !== index))
    if (this.hasSelectTarget) {
      this.selectTarget.value = String(index)
      this.selectTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
    if (this.hasCounterTarget) this.counterTarget.textContent = String(index + 1)
    if (this.hasPersistKeyValue) {
      const id = this.answerTargets[index]?.dataset.id
      if (id) localStorage.setItem(this.persistKeyValue, id)
    }
  }
}
